"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    root: function root(_ref2) {
      var isActive = _ref2.isActive;
      return {
        borderRadius: 5,
        border: "solid 2px ".concat(isActive ? palette.primary.main : palette.grey.timberWolf),
        backgroundColor: isActive ? palette.additional.chambray10 : palette.common.white
      };
    }
  };
});
/**
 * @function
 *
 * @param {object} props
 * @param {string} props.label
 * @param {string} props.value
 * @param {React.ReactNode} props.children
 * @param {boolean} props.isActive
 * @param {React.ReactNode} props.iconNode
 * @param {object} props.wrapperProps
 *
 * @returns {React.ReactElement}
 *
 * @example
 * // TODO: Write example.
 */

var RadioWithContent = function RadioWithContent(_ref3) {
  var label = _ref3.label,
      value = _ref3.value,
      children = _ref3.children,
      isActive = _ref3.isActive,
      iconNode = _ref3.iconNode,
      wrapperProps = _ref3.wrapperProps;
  var classes = useStyles({
    isActive: isActive
  });
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    my: 1,
    p: 3,
    className: classes.root
  }, wrapperProps), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    value: value,
    control: /*#__PURE__*/_react["default"].createElement(_material.Radio, {
      color: "primary"
    }),
    label: label
  }), !isActive && iconNode), isActive && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex"
  }, children));
};

RadioWithContent.propTypes = {
  value: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node,
  isActive: _propTypes["default"].bool,
  iconNode: _propTypes["default"].node,
  // eslint-disable-next-line react/forbid-prop-types
  wrapperProps: _propTypes["default"].object
};
RadioWithContent.defaultProps = {
  children: null,
  iconNode: null,
  isActive: false,
  wrapperProps: {}
};
var _default = RadioWithContent;
exports["default"] = _default;